import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UppercaseDirective } from './uppercase.directive';
import { CustomPasswordValidatorDirective } from './password-validator.directive';
import { MinMaxDirective } from './min-max-input.directive';
import { CurrencyInputMaskDirective } from './currency-input-mask.directive';
import { HoverToolDirective } from './hover-tool.directive';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [UppercaseDirective, CustomPasswordValidatorDirective, MinMaxDirective, CurrencyInputMaskDirective, HoverToolDirective],
  exports: [UppercaseDirective, CustomPasswordValidatorDirective, MinMaxDirective, CurrencyInputMaskDirective, HoverToolDirective],
})
export class DirectivesModule {}
